module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practiceAreas"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("FAALİYET ALANLARI")])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('span', {
    staticClass: "plusActive"
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification "
  }, [_c('ul', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('li', [_vm._v("Fikri ve Sınai Mülkiyet Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Bilgi Teknolojileri, E-Ticaret")]), _vm._v(" "), _c('li', [_vm._v("Alan Adları ve Telekomünikasyon")]), _vm._v(" "), _c('li', [_vm._v("Kişisel Verilerin Korunması")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Deniz ve Taşıma Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Hava Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Gümrük ve Liman İşletmeleri")]), _vm._v(" "), _c('li', [_vm._v("Yabancıların Çalışma ve İkamet İzinleri")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-left is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Dava Takibi ve Ticari Uyuşmazlıklar")]), _vm._v(" "), _c('li', [_vm._v("Sözleşmeler")]), _vm._v(" "), _c('li', [_vm._v("Gayrimenkul Hukuku")]), _vm._v(" "), _c('li', [_vm._v("İnşaat Hukuku")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Yeni Girişimler (Start-Up) ve Uluslararası Yatırımlar")]), _vm._v(" "), _c('li', [_vm._v("İzin, Lisans ve Ruhsatlandırma")]), _vm._v(" "), _c('li', [_vm._v("Medya, Eğlence ve Moda Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Spor Hukuku")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0601eadc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/faaliyet.vue
// module id = 167
// module chunks = 0